import { render } from "./AkaunBelumTerima.vue?vue&type=template&id=723c57f6"
import script from "./AkaunBelumTerima.vue?vue&type=script&lang=js"
export * from "./AkaunBelumTerima.vue?vue&type=script&lang=js"

import "./AkaunBelumTerima.vue?vue&type=style&index=0&id=723c57f6&lang=css"
import "./AkaunBelumTerima.vue?vue&type=style&index=1&id=723c57f6&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__